import { Injectable } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';
import { HttpClient } from '@angular/common/http';
import { AuthConfiguration } from './models/auth-configuration.model';

@Injectable()
export class AuthConfigService {

    authConfig: AuthConfig;
    configuration: AuthConfiguration;
    fullConfigurations: any;

    constructor(private http: HttpClient) { }

    setConfiguration(configurationPath: string): Promise<AuthConfiguration> {
        return new Promise((resolve, reject) => {
            this.http.get(configurationPath).toPromise().then((response: any) => {
                this.configuration = response.configuration;
                this.fullConfigurations = response;
                return resolve(this.configuration);
            }).then(() => resolve())
                .catch(() => reject());
        });
    }

    setupAuthConfig(): AuthConfig {
        return this.authConfig = new AuthConfig({
            issuer: this.configuration.issuer,
            loginUrl: this.configuration.loginUrl,
            postLogoutRedirectUri: this.configuration.postLogoutRedirectUri,
            tokenEndpoint: this.configuration.tokenEndpoint,
            clientId: this.configuration.clientId,
            resource: this.configuration.resource,
            redirectUri: this.configuration.redirectUri,
            scope: this.configuration.scope,
            responseType: this.configuration.responseType,
            requestAccessToken: this.configuration.requestAccessToken,
            oidc: this.configuration.oidc
        });
    } 
}
